var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6C18.6046 6 19.5 5.10457 19.5 4C19.5 2.89543 18.6046 2 17.5 2C16.3954 2 15.5 2.89543 15.5 4C15.5 5.10457 16.3954 6 17.5 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 12.5C13.5037 12.5 13 12.0523 13 11.5C13 9.29086 15.0147 7.5 17.5 7.5C19.9853 7.5 22 9.29086 22 11.5C22 12.0523 21.4963 12.5 20.875 12.5H14.125Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.111 21.1297C14.6039 21.9654 11.9057 22.0159 9.37549 21.2813C9.45629 21.0355 9.5 20.7729 9.5 20.5V15.5C9.5 15.2515 9.46373 15.0114 9.39619 14.7848C11.2132 14.2852 13.1183 14.1864 14.9795 14.4966L15.549 14.5915C16.317 14.7195 16.8929 15.2604 17.1179 15.9318L14.7437 16.7952C14.3544 16.9367 14.1536 17.367 14.2952 17.7563C14.4367 18.1456 14.867 18.3464 15.2563 18.2048L17.6228 17.3443L19.9824 16.7544C21.0073 16.4982 22 17.2733 22 18.3297C22 19.0286 21.5528 19.6491 20.8897 19.8701L17.111 21.1297Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.5C2.44772 14.5 2 14.9477 2 15.5V20.5C2 21.0523 2.44772 21.5 3 21.5H7C7.55228 21.5 8 21.0523 8 20.5V15.5C8 14.9477 7.55228 14.5 7 14.5H3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.368c7da5e7ef705c8524f126a25db276.svg";
export { ForwardRef as ReactComponent };